import { defineMessages } from "react-intl";

export default defineMessages({
    issueButton: {
        id: "components__version-selector__issue-button",
        defaultMessage: "Issues",
    },
});
